// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".restaurant-map[data-v-708d7991]{position:relative}@media(min-width:768px){.base-map[data-v-708d7991]  .map-container{padding-bottom:87.8787878788%}}.directions[data-v-708d7991]{position:absolute;bottom:40px;left:50%;transform:translateX(-50%)}.directions .btn[data-v-708d7991]{padding-left:1.875rem;padding-right:1.875rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
